import React from 'react';
import SubjectPage from '../structure/SubjectPage';
import Accordions from '../../../components/Dropdowns';

const TW = ({ branch = "CSE", semester = "4th Semester" }) => {
  const accordionContent = [
    <div key="1" className="p-4">
      <p>Grammar and Vocabulary - Types of sentences (simple, complex and compound) and use of connectives in sentences, Subject-verb agreement, Comprehension, Synonyms and Antonyms, Homophones and Homonyms, Word Formation: Prefixes and Suffixes, Indianism, Misappropriation and Redundant Words, Question Tags and Short Responses.</p>
    </div>,
    <div key="2" className="p-4">
      <p>Writing Styles - Expository, Explanatory, Descriptive, Argumentative and Narrative, Precis writing, Visual Aids in Technical Writing, Plagiarism and Language Sensitivity in Technical Writing, Dialogue Writing, Proposals: Purpose and Types.</p>
    </div>,
    <div key="3" className="p-4">
      <p>Letters at the Workplace - letter writing: Request, Sales, Enquiry, Order and Complaint, Job Application - Resume and Cover letter, Difference between Resume and CV, Preparation for Interview, Meeting Documentation - Notice, Memorandum, Circular, Agenda, Office Order and Minutes of meeting, Writing Instructions.</p>
    </div>,
    <div key="4" className="p-4">
      <p>Ethics and Personality Development - The Role of Ethics in Business Communication - Ethical Principles, Time Management, Self-Analysis through SWOT and JOHARI Window, Emotional Intelligence and Leadership Skills, Team Building, Career Planning, Self Esteem.</p>
    </div>
  ];

  const tabData = [
    {
      id: 'syllabus',
      label: 'Syllabus',
      content: <Accordions accordionContent={accordionContent} />,
    },
    {
      id: 'notes',
      label: 'Notes',
      content: null, // Managed by SubjectPage
    },
    {
      id: 'important',
      label: 'Important Questions',
      content: null, // Managed by SubjectPage
    },
    {
      id: 'books',
      label: 'Books',
      content: null, // Managed by SubjectPage
    },
    {
      id: 'PYQ',
      label: 'PYQ',
      content: null, // Managed by SubjectPage
    },
    {
      id: 'videos',
      label: 'Video Lectures',
      content: null, // Managed by SubjectPage
    }
  ];

  return (
    <SubjectPage
      subjectName="Technical Writing"
      subjectKey="tw"
      branch={branch}
      semester={semester}
      accordionContent={accordionContent}
      tabData={tabData}
      adminEmail="snaped4338@gmail.com"
      firestoreCollections={{
        notes: 'TWNotes',
        videos: 'TWVideos'
      }}
    />
  );
};

export default TW;
